import { ConfigField, ConfigGETResponseSuccess, featureFlagsKeys } from '@contracts'
import { FilterLoadData } from './appContext'

export const getNewFilterSelection = (
  reducerId: string,
  filterSelection: FilterLoadData[],
  currentFilterSelection: Record<string, FilterLoadData[]>,
): Record<string, FilterLoadData[]> => {
  const newFilterSelection = { ...currentFilterSelection }

  newFilterSelection[reducerId] = filterSelection.map(selectedFilter => ({
    filterId: selectedFilter.filterId,
    activeFilters: selectedFilter.activeFilters,
  }))

  return newFilterSelection
}

function getIsConfigField(value: string): value is ConfigField {
  return Object.values(featureFlagsKeys).includes(value as ConfigField)
}

export function extractFeatureFlags(res: ConfigGETResponseSuccess) {
  let featureFlags: { [K in ConfigField]?: boolean } = {}
  for (const key in res.config) {
    const configField = key as ConfigField
    const value = res.config[configField]

    if (value) {
      featureFlags[configField] = value.enabled || false
      for (const attributeKey in value) {
        if (getIsConfigField(attributeKey)) {
          featureFlags[attributeKey] = value[attributeKey] as boolean
        }
      }
    }
  }

  return featureFlags
}
